// src/pages/staff/StaffChecklist.js
import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { serverTimestamp } from "firebase/firestore";

export default function StaffChecklist() {
  const { shiftId } = useParams();
  const [tasks, setTasks] = useState([]);
  const [completed, setCompleted] = useState({});
  const [clientName, setClientName] = useState("");
  const [loading, setLoading] = useState(true);

  // NEW: staff notes
  const [staffNotes, setStaffNotes] = useState("");
  const [savingNotes, setSavingNotes] = useState(false);

  useEffect(() => {
    const load = async () => {
      const shiftRef = doc(db, "shifts", shiftId);
      const shiftSnap = await getDoc(shiftRef);

      if (!shiftSnap.exists()) {
        setLoading(false);
        return;
      }

      const shiftData = shiftSnap.data();
      const clientId = shiftData.clientId;

      if (clientId) {
        const clientSnap = await getDoc(doc(db, "clients", clientId));
        if (clientSnap.exists()) {
          const cData = clientSnap.data();
          setClientName(cData.fullName || cData.name || "Client");
          setTasks(cData.toDoList || []);
        }
      }

      setCompleted(shiftData.tasksCompleted || {});
      setStaffNotes(shiftData.staffNotes || "");
      setLoading(false);
    };

    load();
  }, [shiftId]);

  const toggleTask = async (taskId) => {
    const newCompleted = {
      ...completed,
      [taskId]: !completed[taskId],
    };
    setCompleted(newCompleted);

    await updateDoc(doc(db, "shifts", shiftId), {
      tasksCompleted: newCompleted,
    });
  };

  const handleSaveNotes = async () => {
  setSavingNotes(true);
  try {
    await updateDoc(doc(db, "shifts", shiftId), {
      staffNotes,
      staffNotesUpdatedAt: serverTimestamp(),
      reportReady: true     // <-- mark report as available
    });

    alert("Notes saved!");
  } catch (e) {
    console.error(e);
    alert("Failed to save notes.");
  } finally {
    setSavingNotes(false);
  }
};


  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen text-gray-500">
        Loading tasks…
      </div>
    );
  }

  if (!tasks.length) {
    return (
      <div className="p-6 text-center text-gray-500">
        <h1 className="text-xl font-bold mb-2">Tasks for {clientName}</h1>
        <p>No tasks have been set for this client.</p>
      </div>
    );
  }

  const completedCount = Object.values(completed).filter(Boolean).length;

  return (
    <div className="p-6 pt-20 min-h-screen bg-gray-100 text-gray-800">
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          backgroundColor: "white",
          borderRadius: "16px",
          padding: "24px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
        }}
      >
        <h1 className="text-xl font-bold text-gray-700 mb-1">
          Tasks for {clientName}
        </h1>
        <p className="text-sm text-gray-500 mb-4">
          {completedCount} / {tasks.length} tasks completed
        </p>

        <div className="space-y-2">
          {tasks.map((task) => (
            <label
              key={task.id}
              className="flex items-center space-x-5 bg-white p-3 rounded-2xl shadow-sm border border-gray-100"
            >
              <input
                type="checkbox"
				
                className="w-5 h-5"
                checked={!!completed[task.id]}
                onChange={() => toggleTask(task.id)}
              />
              <span
			    style={{ marginLeft: "10px" }}
                className={
                  completed[task.id]
                    ? "line-through text-gray-400"
                    : "text-gray-700"
                }
              >
                {task.text}
              </span>
            </label>
          ))}
        </div>

        {/* Staff notes section */}
        <div className="mt-6">
          <h2 className="text-sm font-semibold text-gray-700 mb-2">
            Visit Notes (for office / records)
          </h2>
          <textarea
            value={staffNotes}
            onChange={(e) => setStaffNotes(e.target.value)}
            rows={4}
            className="w-full border border-gray-300 rounded-xl p-3 text-sm focus:outline-none focus:ring-2 focus:ring-pink-400"
            placeholder="Describe anything important about this visit…"
          />
          <button
            onClick={handleSaveNotes}
            disabled={savingNotes}
            className="mt-3 w-full bg-pink-500 text-white py-2 rounded-xl font-semibold text-sm disabled:bg-gray-400"
          >
            {savingNotes ? "Saving…" : "Save Notes"}
          </button>
        </div>
      </div>
    </div>
  );
}
